<template>
  <div class="home">
    <div class="top">
      <!--左边标题-->
      <div class="title" style="display: flex;align-items:center">{{ $t('header.bbzn') }} <span class="circle" style=""></span> {{ $t('header.hyn') }}</div>
      <!--中间部分-->
      <li class="merchants" style="border:1px solid white">
        <div class="phone">
          <img src="../../assets/topNav/fdngiudfgidhfi.png" alt="" />
          <a :href="'tel:' + companyInfoList.title" class="call">{{companyInfoList.title }}</a>
        </div>
      </li>
      <!--右侧菜单栏-->
      <div class="platform">
        <!--语言菜单-->
        <div class="english">
          <svg t="1682162377970"
               @click="showchoose=true"
               style="vertical-align:middle"
               class="icon ddsasvgf"
               viewBox="0 0 1024 1024"
               version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="2255"
               width="16"
               height="16">
            <path d="M496 0C222.048 0 0 222.048 0 496S222.048 992 496 992 992 769.952 992 496 769.952 0 496 0z m431.2 480h-191.872c-1.76-70.88-14.368-138.592-36.736-200.576a522.688 522.688 0 0 0 119.552-70.304A429.856 429.856 0 0 1 927.2 480zM478.304 927.104c-53.184-44.288-97.792-101.792-130.432-168.576A495.904 495.904 0 0 1 480 736.8v190.368l-1.696-0.064z m35.328-862.208c60.352 50.24 109.6 117.536 142.912 196.032-45.632 15.584-94.112 24.64-144.576 26.24V64.8l1.664 0.096z m53.312 5.44a430.816 430.816 0 0 1 229.248 115.648 489.504 489.504 0 0 1-109.696 63.936c-29.12-69.024-69.984-130.048-119.552-179.584zM480 64.8v222.368a495.744 495.744 0 0 1-144.576-26.24c33.312-78.496 82.56-145.792 142.912-196.032L480 64.8zM305.472 249.952a490.72 490.72 0 0 1-109.664-63.936 430.72 430.72 0 0 1 229.248-115.648c-49.6 49.504-90.432 110.528-119.584 179.584z m17.888 40.48c49.344 17.12 101.92 27.104 156.64 28.768V480H288.672c1.728-67.008 13.6-131.04 34.688-189.568zM480 512v192.8a525.152 525.152 0 0 0-145.248 24.608A601.12 601.12 0 0 1 288.672 512H480z m-54.944 409.664a429.792 429.792 0 0 1-209.44-97.664 486.368 486.368 0 0 1 102.016-54.4 554.144 554.144 0 0 0 107.424 152.064z m86.944 5.536v-190.368c45.824 1.472 90.24 8.64 132.128 21.728-32.672 66.784-77.248 124.288-130.432 168.576a31.2 31.2 0 0 0-1.696 0.064z m162.368-157.6a490.24 490.24 0 0 1 102.016 54.4 430.08 430.08 0 0 1-209.44 97.664 554.816 554.816 0 0 0 107.424-152.064z m-17.12-40.192A525.568 525.568 0 0 0 512 704.8V512h191.328a601.792 601.792 0 0 1-46.08 217.408zM512 480V319.2a526.08 526.08 0 0 0 156.64-28.736c21.056 58.528 32.928 122.56 34.688 189.568H512zM173.888 209.12a523.2 523.2 0 0 0 119.52 70.304C271.04 341.408 258.432 409.12 256.672 480H64.8a429.728 429.728 0 0 1 109.088-270.88zM64.8 512h191.872a631.168 631.168 0 0 0 48.096 228.384 519.36 519.36 0 0 0-113.216 61.792A430.816 430.816 0 0 1 64.8 512z m735.648 290.144a520.192 520.192 0 0 0-113.248-61.792 631.2 631.2 0 0 0 48.128-228.384h191.872a430.848 430.848 0 0 1-126.752 290.176z"
                  fill="#ffffff"
                  p-id="2256"></path>
          </svg>
          <img v-if="isMob"
               class="wwqs"
               :src="flagSrc"
               style="width:40px;height:25px;border-radius: 0;vertical-align: middle;"
               alt="">
          <select name=""
                  v-if="isMob"
                  style="border:none; background-color: transparent;color: #fff; margin-right:10px;text-align: center;vertical-align: middle;"
                  id=""
                  v-model="lang"
                  @change="changeLang">
            <option v-for="(item,index) of langs"
                    :key="index"
                    :value="item.name"
                    @click="changeflag(item)">
              <div>
                <img style="width:20px;height:20px"
                     :src="item.img"
                     alt="">{{ item.name }}

              </div>
            </option>
          </select>
          <img :src="flagImg"
               v-if="!isMob"
               style="border-radius: 0;vertical-align: middle;margin-right:-25px;margin-left: 10px;"
               alt="">
          <el-select v-if="!isMob"
                     style="width:80px;background: transparent;"
                     @change="changeflag_pc"
                     v-model="lang">
            <el-option v-for="(item,index) of langs"
                       :key="index"
                       :value="item.name">
              <div>
                <img style="width:25px;height:18px;vertical-align: text-bottom;margin-right:3px"
                     :src="item.img"
                     alt="">{{ item.name }}

              </div>
            </el-option>
          </el-select>
          <!-- <select name=""
                  v-else
                  style="border:none; background-color: transparent;color: #fff; margin-right:10px;text-align: center;vertical-align: middle;"
                  id=""
                  v-model="lang"
                  @change="changeLang">
            <option value="zh">中文 </option>
            <option value="en">English</option>
            <option value="ru">Русский язык</option>
            <option value="de">Deutsch</option>
            <option value="fr">Français</option>
            <option value="ar">بالعربية</option>
            <option value="es">Español</option>
          </select> -->
        </div>
        <!--登录菜单-->
        <div class="login" style="margin-top:-2px;">
          <p class="name"
             v-if="loginShow"
             @click="addLogin">
            <i class="el-icon-user"></i> {{ $t('header.qdl') }}
          </p>
          <img v-if="!loginShow"
               :src="userInfo.headImg"
               alt="" />
          <p v-if="!loginShow"
             class="username">{{ userInfo.username }}</p>
          <div v-if="!loginShow"
               class="dropdown">
            <span @click="logOut">{{ $t('header.tcdl') }}</span>
          </div>
        </div>
        <!--订单菜单-->
        <ul class="shopp" style="margin-top:-4px;">
          <li @click="dddedd" class="tickets">
            <i class="el-icon-tickets"></i>
            <span> {{ $t('header.wddd') }}</span>
          </li>
          <!--购物车-->
          <li class="shopping-box">
            <el-badge :value="shoppingList.length"  class="item" v-if="shoppingList.length>0">
              <i @click="shopping" class="el-icon-shopping-cart-full" style="margin-top:4px;"><span> {{ $t('header.gwc') }}</span></i>
            </el-badge>
            <i @click="shopping" class="el-icon-shopping-cart-full" style="margin-top:6px;" v-else><span> {{ $t('header.gwc') }}</span></i>
          </li>
          <!--平台登录-->
          <li class="platform" style="padding-top:3px;" @click="getPlatform" v-for="(item, index) in platformList" :key="index">
            <a target="_blank"
               :href="item.link"><i class="el-icon-s-platform"></i> {{ $t('header.ptdl') }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="containers"
         :class="navShow ? 'navOn' : 'navOff'">
      <!--logo图标-->
<!--      <div class="logos">-->
<!--        <a title="" href="/">-->
<!--          <img src="../../assets/topNav/logo.jpg" class="logo0" alt="" style="width:40px;height:40px;border-radius: 8px;" />-->
<!--        </a>-->
<!--      </div>-->
      <div class="headers">
        <el-dropdown trigger="click" size="small" @command="handleCommand">
          <div class="drop-dowm">
            <span>{{ $t('header.dhl') }}</span>
            <i style="vertical-align: middle"
               class="el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <template v-for="(item,index) in navList">
              <el-dropdown-item v-model:key="item.path" :command="item">
                <div>{{ item.name }}</div>
                <i class="el-icon-caret-right"></i>
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="header-rights">
        <div class="nav container">
          <ul>
            <li v-for="(item, index) in navList"
                :class="[tabShou === item.path ? 'active' : 'nav-item']"
                @click="addTab(item)"
                :key="index">
              <a :style="{'font-size':fontSize+'px'}">{{ item.name }}</a>
              <div class="transition"
                   v-if="item.children">
                <p v-for="(i, j) in item.children"
                   @click.stop="addTransition(item, i)"
                   :key="j">
                  {{ i.name }}
                </p>
              </div>
            </li>

            <li class="merchants">
              <div class="phone">
                <img src="../../assets/topNav/phone.png"
                     alt="" />
                {{ companyInfoList.title }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 选择语言 -->
    <div v-if="showchoose"
         style="width:75%;height:80%;position:fixed;left:50%;top:50%;transform: translate(-50%,-50%);box-shadow:rgb(58 58 58) 0px 0px 4px 2px;border-radius: 10px;">
      <div style="width:100%;height:100%;display: flex;flex-direction: column;">
        <div style="flex:1;width:100%; padding:10px 9%;box-sizing: border-box;background:#5c5c5c7d;border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;position: relative;">
          <div style="position:absolute;height:100%;width:120px;left:20%;top:0;">
            <div style="height:100%;display: flex;flex-direction:column;justify-content: center;">
              <div style=" margin: 20px 0;display: flex;align-items: center;"
                   v-for="(item,index) of langs"
                   :key="index"
                   @click="changeLang({currentTarget:{value:item.key}})">
                <img :src="item.img"
                     alt=""
                     style="width:60%;margin-right: 50px;">
                <span style="margin: 0;text-align: center;font-size:30px;display: inline-block;font-weight: bold;color:#000;white-space: nowrap;">
                  {{ item.name }} <span>{{ item.desc }}</span>
                </span>
                <img :src="arrow"
                     alt=""><img :src="arrow"
                     alt=""><img :src="arrow"
                     alt=""><img :src="arrow"
                     alt=""><img :src="arrow"
                     alt="">
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data () {
    return {
      langShow: false,
      showchoose: false,
      flagSrc: '',
      isMob: false,
      langtype: 0,
      fontSize: 0,
      platformList: [
        {
          name: "平台登录",
          link: `https://www.babaznkj.com/#/login`,
        },
      ],
      lang: '',
      arrow: require('../../assets/header/arrow.png'),
      dropdownList: [
        {
          name: "发布",
          type: "release",
        },
        {
          name: "我的订单",
          type: "order",
        },
        {
          name: "编辑信息",
          type: "edit",
        },
        {
          name: "实名认证",
          type: "real",
        },
        {
          name: "余额与提现",
          type: "balance",
        },
        {
          name: "退出登陆",
          type: "signOut",
        },
      ],
      subnavList: [
        "公司简介",
        "公司资质",
        "生产基地",
        "联系我们",
        "公司简介",
        "索取报价",
      ],
      navList: [
        {
          name: this.$t('nav.cpzx'), // 产品中心
          path: "product",
          children: [
            
          ],
        }, // 产品中心
        {
          name: this.$t('nav.jjfa'),
          path: "solution",
          children: [
            { name: this.$t('nav.zhcs'), distance: 950, id: 48 },
            { name: this.$t('nav.zhgc'), distance: 1350, id: 43 },
            { name: this.$t('nav.zhxf'), distance: 1700, id: 45 },
            { name: this.$t('nav.zhgd'), distance: 2050, id: 44 },
            { name: this.$t('nav.zhsq'), distance: 2500, id: 46 },
            { name: this.$t('nav.zhxy'), distance: 3000, id: 47 },
          ],
        }, // 解决方案
        { name: this.$t('nav.xmal'), path: "case" }, // 项目案例
        {
          name: this.$t('nav.bbzx'),
          path: "dynamic",
          children: [
            { name: this.$t('nav.bbdt'), distance: 650, tab: 0 },
            { name: this.$t('nav.hydt'), distance: 650, tab: 1 },
            { name: this.$t('nav.bbbk'), distance: 650, tab: 2 },
          ],
        }, // 资讯
        {
          name: this.$t('nav.fwzc'), // 服务支持
          path: "serve",
          children: [
            { name: this.$t('nav.zlxz'), tab: 0 },
            { name: this.$t('nav.rjxz'), tab: 1 },
            { name: this.$t('nav.gysly'), tab: 2 },
            { name: this.$t('nav.yhxy'), tab: 3 },
            { name: this.$t('nav.ystk'), tab: 4 },
            { name: this.$t('nav.fhtkzc'), tab: 5 },
          ],
        }, // 服务支持
        { name: this.$t('nav.zsdl'), path: "agent" }, // 招商代理
        {
          name: this.$t('nav.gybb'),
          path: "about",
          children: [
            { name: this.$t('nav.bbjj'), distance: 650, tab: 0 },
            // { name: this.$t('nav.bbwh'), distance: 650, tab: 1 },
            // { name: this.$t('nav.ryzz'), distance: 650, tab: 2 },
            { name: this.$t('nav.lxwm'), distance: 650, tab: 1 },
          ],
        }, // 关于我们
        { name: this.$t('nav.zxsp'), path: "video" }, // 在线视频
        { name: this.$t('nav.hylt'), path: "homes" }, // 行业论坛
        { name: this.$t('nav.appdown'), path: "app" }, // 佳智惠app
      ],
      tabShou: "",
      value: "",
      loginShow: true,
      userInfo: {},
      shoppingList: [],
      top: "",
      navShow: 1,
      shoppingNum: null,
      url: "",
      companyInfoList: {},
      flagImg: '',
      langs: [
        {
          key: 'zh',
          name: 'ZH',
          img: 'https://t10.baidu.com/it/u=859361324,994557640&fm=58&app=83&f=JPG?w=200&h=133',
          desc: '请选择中文显示'
        }, {
          key: 'en',
          name: 'EN',
          img: 'https://t12.baidu.com/it/u=3291953939,811144527&fm=58&app=83&f=JPG?w=200&h=133',
          desc: 'Please select English display'
        }, {
          key: 'ru',
          name: 'RU',
          img: 'https://t11.baidu.com/it/u=281011146,3306640066&fm=58&app=83&f=JPG?w=200&h=133',
          desc: ' Пожалуйста, выберите русский '
        }, {
          key: 'de',
          name: 'DE',
          img: 'https://t10.baidu.com/it/u=2695984996,2561296436&fm=58&app=83&f=JPG?w=200&h=120&s=2B075A6E8DEBA32C725686AC0200C04A',
          desc: 'Bitte wählen Deutsche Anzeige'
        }, {
          key: 'ar',
          name: 'AR',
          img: 'https://t10.baidu.com/it/u=3048194595,959846079&fm=58&app=83&f=JPG?w=200&h=133',
          desc: ' الرجاء اختيار العرض العربي '
        }, {
          key: 'es',
          name: 'ES',
          img: 'https://t10.baidu.com/it/u=1870552204,3964679659&fm=58&app=83&f=JPEG?w=200&h=132',
          desc: 'Por favor, elija el español para mostrar'
        }, {
          key: 'fr',
          name: 'FR',
          img: 'https://t12.baidu.com/it/u=2607855200,2266322315&fm=58&app=83&f=JPEG?w=200&h=133',
          desc: 'Veuillez sélectionner français afficher'
        },
      ]
    };
  },
  name: "topNav",
  components: {},
  created () {
    this.isMob = this.isMobile() //移动端判断
    if (!this.isMobile()) { // 电脑端
      if (localStorage.getItem('lang')) {
        switch (localStorage.getItem('lang')) {
          case "zh":
            this.langtype = 0;
            break;
          case "en":
            this.langtype = 1;
            break;
          case "es":
            this.langtype = 6;
            break;
          case "ru":
            this.langtype = 2;
            break;
          case "de":
            this.langtype = 3;
            break;
          case "fr":
            this.langtype = 4;
            break;
          case "ar":
            this.langtype = 5;
            break;
        }
      }
      // else {
      //   this.showchoose = true
      //   setTimeout(() => {
      //     this.showchoose = false
      //   }, 1000 * 10)
      // }
    } else {
      if (localStorage.getItem('lang')) {
        for (var item of this.langs) {
          if (item.key === localStorage.getItem('lang')) {
            this.flagSrc = item.img
          }
        }
      }
    }


    this.tabShou = this.$route.name;
    this.addLoginShow();
    let _this = this;
    window.addEventListener("setItemEvent", function (e) {
      //e.key : 是值发生变化的key
      console.log()
      if (e.key === "shoppingNum") {
        console.log(e.newValue);
        _this.addShopping();
      }
    });
  },
  mounted () {    
    this.companyInfo();
    if (localStorage.getItem('lang') === 'zh') {
      this.fontSize = 18
    } else {
      this.fontSize = 16
    }
    window.addEventListener("scroll", () => {
      this.top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
    });

    this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang').toUpperCase() : navigator.language.split('-')[0].toUpperCase()
    for (var item of this.langs) {
      if (item.name === this.lang) {
        this.flagImg = item.img
      }
    }
  },
  methods: {
    changeflag_pc (e) {
      console.log(e)
      var la = String(e)
      localStorage.setItem('lang', la.toLowerCase())
      window.location.reload()
    },
    changeflag (e) {
      if (this.isMob) {
        this.flagSrc = e.img
      }
    },
    changeLang (e) {
      
      console.log(e.currentTarget.value)
      localStorage.setItem('lang', e.currentTarget.value.toLowerCase())
      window.location.reload()
      // document.location.href = document.location.host
    },
    async companyInfo () {
      let classifyImg = await this.api.get(this.apiPath.classifyImg, {});
      var arr = []
      classifyImg.items.sort((a, b) => a.index - b.index)
      console.log(classifyImg.items)
      var obj = {
        "智能安全帽": 'safetyHat',
        "烟雾报警器": 'smokeDetector',
        "定位手表": 'watch',
        "智慧用电": 'smartElectricity',
        "智能水表": 'waterMeter',
        "智能平台": 'platForm',
        "越野房车": 'touringCar',
        "消防车辆": 'fireEngine',
        "监控设备": 'monitor'
      }
      for (var item of classifyImg.items) {
        console.log(item)
        arr.push({
          name: item.names ? JSON.parse(item.names)[this.langtype] || item.name : item.name,
          path: 'product/' + obj[item.name]
        })
      }
      console.log(arr)
      this.navList[0].children = arr
      let res = await this.api.get(this.apiPath.companyInfo, {});
      console.log(res)
      localStorage.setItem("companyInfo", JSON.stringify(res));
      this.companyInfoList = JSON.parse(localStorage.getItem("companyInfo"));
    },
    async getPlatform () {
      const userMap = localStorage.getItem("userMap");
      this.platformList[0].link = `https://www.babaznkj.com/#/login?id=${JSON.parse(userMap).id
        }`;
      let data = {
        id: String(JSON.parse(userMap).id),
        username: JSON.parse(localStorage.getItem("params")).username,
        password: JSON.parse(localStorage.getItem("params")).password,
      };
      let res = await this.api.post(this.apiPath.jump, data);
      console.log(res);
    },
    dddedd () {
      this.$router.push({
        path: "/MyOrder",
      });
    },
    addTab (item) {
      this.tabShou = item.path;
      console.log('切换/')
      this.$router.push({
        path: `/${item.path}`,
      });
      
    },
    addLogin () {
      this.$router.push({
        path: "/login",
      });
    },
    async addTransition (item, i) {
      console.log('addtrans', item, i)
      console.log(item.path)
      if (item.path == "solution") {
        this.$router.push({
          path: "/solutionDetail?id=" + i.id,
        });
      } else if (item.path == 'dynamic') {
        // localStorage.setItem("sharing", i.name);
        this.$router.push({
          path: `/dynamic?tab=` + i.tab,
        });
      } else if (item.path == 'serve') {
        // localStorage.setItem("sharing", i.name);
        await this.$router.push({
          path: `/serve?tab=` + i.tab,
        });
        // this.$router.push({
        //   path: '/' + localStorage.getItem('lang') + '/' + i.path,
        // });
        location.reload();

        
      } else if (item.path == 'product') {
        this.$router.push({
          path: '/' + i.path,
        });
      } else if (item.path == 'about') {
        this.$router.push({
          path: '/about?tab=' + i.tab
        })
      } else {
        // localStorage.setItem("sharing", i.name);
        this.$router.push({
          path: `/${item.path}`,
        });
        if (i.distance) {
          document.documentElement.scrollTop = i.distance;
        }
      }
     
    },
    addLoginShow () {
      let userMap = JSON.parse(localStorage.getItem("userMap"));
      if (userMap) {
        this.userInfo = userMap;
        this.addShopping();
      }
      const token = localStorage.getItem("token");
      if (token) {
        this.loginShow = false;
      }
    },
    logOut () {
      this.$confirm("您确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          setTimeout(() => {
            localStorage.clear();
            this.$router.push("/login");
          }, 16);
        })
        .catch(() => { });
    },
    async addShopping () {
      let shoppingList = await this.api.get(this.apiPath.shoppingList, {});
      this.shoppingList = shoppingList;
    },
    shopping () {
      this.$router.push({
        path: "/shopping",
      });
    },
    handleCommand (command) {
      console.log(command);
      this.$router.push({
        path: `/${command.path}`,
      });
    },
  },
  watch: {
    $route (val) {
      this.tabShou = val.name;
    },
    top (newValue, oldValue) {
      // 等新值大于100的时候再做变化（优化一下）
      //   if (newValue > 100) {
      if (newValue > 1) {
        if (newValue > oldValue) {
          this.navShow = false;
          //向下滚动
        } else {
          //向上滚动
          this.navShow = true;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-input__inner {
  background-color: transparent !important;
  text-align: right;
  color: #fff;
  border: none;
}
#product a:hover .subnav {
  display: block;
}
.header .header-right .nav ul li:hover .subnav {
  display: block;
  background: rgba(255, 255, 255, 0.8);
}
.nav {
  width: 1300px;
  margin-left: 100px;
}
.title .circle {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #fff;
  margin: 0 10px;
}
@media (max-width: 1550px) {
  .nav {
    width: 1060px;
    margin: 0;
  }
}
.nav ul li {
  font-size: 18px;
  cursor: pointer;
}
.home {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .phone {
    // font-size: 30px;
    // line-height: 105px;
    // margin-left: 20px;
    // color: #7F0114;
    img {
      width: 34px;
      height: 34px;
    }
  }
  .login {
    margin-top: 2px;
    position: relative;
    color: #fff !important;
    font-size: 14px;
    margin-right: 20px;
    cursor: pointer;
    display: flex;
    .name {
      z-index: 99;
    }
    .username {
      margin-top: 2px;
      margin-right: 15px;
      line-height: 28px;
      font-size: 16px;
    }
    .dropdown {
      width: 100px;
      height: 80px;
      background: #7f0114;
      position: absolute;
      top: 26px;
      left: 0px;
      // border-radius: 10px;
      border-radius: 0 0 10px 10px;
      padding: 10px;
      display: none;
      z-index: 99;
    }
  }
  .login :hover {
    transition: 0.5s;
  }
  .login:hover .dropdown {
    display: block;
  }
}
.tickets {
  margin-top: 2px;
  cursor: pointer;
}
.platform {
  margin-top: 2px;
  .english {
    text-align: center;
    a {
      color: #fff;
      margin-right: 30px;
      font-size: 14px;
      display: flex;
      text-align: center;
      align-items: center;
    }
    img {
      width: 25px !important;
      height: 18px !important;
    }
  }
}
.top {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: auto;
  background: #7f0114;
  color: #fff;
  padding: 0 20px;
  .title {
    font-size: 18px;
    margin-left: 10%;
  }
  .merchants {
    display: none;
  }
  .platform {
    display: flex;
    align-items: center;

    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin-right: 5px;
    }
    ul {
      display: flex;
      li {
        // width: 100px;
        margin-left: 11px;
        white-space: nowrap;
        a {
          color: #fff;
        }
      }
    }
  }
}
.headers {
  display: none;
  .drop-dowm {
    padding: 0 20px;
    .el-icon-s-unfold {
      font-size: 28px;
    }
  }
}
.navOn {
  opacity: 1;
  transition: all 0.2s ease-in-out 0.2s;
  transform: translateZ(0);
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-evenly;
  padding: 0 10px;
  align-items: center;
  background: #fff;
}
.navOff {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  opacity: 0;
  transition: all 0.2s ease-in-out 0.2s;
  transform: translate3d(0, -200%, 0);
}
.containers {
  .header-rights {
    // flex: 1;
    li {
      position: relative;
      .transition {
        width: 180px;
        background: #eee;
        position: absolute;
        top: 40px;
        left: 50%;
        transform: translate(-50%, 0);
        p {
          font-size: 15px;
          /* min-height: 30px; */
          padding: 10px 10px;
          line-height: 21px;
          text-align: center;
          border-bottom: 1px solid #ffffff;
          box-sizing: border-box;
        }
        P:last-child {
          border-bottom: 0;
        }
        p:hover {
          background: #7f0114;
          color: #fff;
        }
      }
    }

    ul {
      display: flex;
      justify-content: space-around;
      .transition {
        display: none;
        animation: to 0.5s;
        overflow: hidden;
      }
      li:hover .transition {
        display: block;
        animation: from 0.1s;
        overflow: hidden;
      }
      @keyframes from {
        from {
          height: 0;
        }

        to {
          height: 100%;
        }
      }

      @keyframes to {
        from {
          height: 100%;
        }

        to {
          height: 0;
        }
      }
      li {
        // margin-right: 3%;
        line-height: 40px;
        a {
          color: #000;
          font-weight: bold;
          font-size: 18px;
        }
        a:hover {
          color: #7f0114;
        }
      }
      .active a {
        color: #7f0114;
      }
    }
  }
}
.merchants {
  .phone {
    display: flex;
    align-items: center;
    font-size: 30px;
    margin-left: 20px;
    color: #7f0114;
    img {
      width: 40px;
      height: 40px;
    }
    a {
      color: #fff;
    }
  }
}

@media (max-width: 1550px) {
  .nav {
    width: 1060px;
    margin: 0;
  }
}
@media screen and (min-width: 800px) {
}
@media screen and (max-width: 750px) {
  .title .circle {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: #fff;
    margin: 0 3px;
  }
  .el-message-box {
    width: 200px !important;
  }
  .shopp {
    .platform {
      display: none;
    }
  }
  .platform {
    display: none;
    .img {
      width: 25px;
      height: 25px;
    }
    .english {
      width: 68px;
      margin-right: 1px;
    }
    .english a {
      margin-right: 0;
      font-size: 12px;
      // display: none;
    }
  }
  .title {
    display: none;
  }
  .top {
    padding: 0;
    width: 100%;
    .merchants {
      display: block;
      .phone {
        width: 110px;
        height: 50px;
        display: flex;
        align-items: center;
        font-size: 11px;
        margin-left: 0;
        color: #fff;
        img {
          width: 25px;
          height: 25px;
        }
      }
    }
    .title {
      margin-left: 3px;
      font-size: 1px;
      // width: 50%;
    }
    .platform {
      .ul {
        .li {
          margin-right: 0;
        }
      }
    }
  }
  .home .login {
    margin-right: 0px;
  }
  .top .platform ul li {
    margin-right: 2px;
    // width: 29px;
  }
  .home .login .username {
    width: 40px;
    font-size: 12px;
    margin-right: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .shopp {
    .tickets {
      width: 19px !important;
      .el-icon-tickets {
        font-size: 17px;
      }
      span {
        display: none;
      }
    }
    .shopping-box {
      margin-top: 2px;
      span {
        display: none;
      }
      .el-icon-shopping-cart-full {
        font-size: 17px;
      }
      // display: none !important;
    }
  }
  .headers {
    display: block;
  }
  .header-rights {
    display: none;
  }
  .navOn {
    height: 80px;
    justify-content: space-between;
    .logos {
      padding: 20px;
      img {
        height: 30px !important;
      }
    }
  }
  .login .name {
    margin-left: 0px;
  }
}
.el-dropdown-menu {
  width: 300px;
  left: 0;
}
.el-dropdown-menu__item {
  display: flex;
  justify-content: space-between;
}

.platform {
  margin-top: 0;
}
select option {
  color: #000;
}
</style>
<style>
@media screen and (max-width: 750px) {
  .el-message-box {
    width: 300px !important;
  }
  .title {
    display: none !important ;
  }
  .top {
    height: 35px !important ;
  }
  .login img {
    width: 20px !important ;
    height: 20px !important ;
  }
  .home .login .username {
    line-height: 18px !important ;
    margin-top: 0 !important ;
  }
  .top .platform ul li {
    margin-right: 12px !important ;
  }
  .platform .english {
    width: auto !important;
  }
  .navOn {
    height: 40px !important;
  }
  .navOn .logos img {
    height: 30px !important;
  }
  .navOn .logos {
    padding: 0 20px !important;
  }
  #main {
    margin-top: 75px !important;
  }
  .inmain .product {
    padding-top: 12px !important;
  }
  .second-nav ul .box {
    width: 56px !important;
  }
  .second-nav ul li {
    margin-right: 19px !important;
  }
  .second-nav ul li .pic {
    width: 25px !important;
    height: 25px !important ;
  }
  .ddsasvgf {
    display: none;
  }
}
</style>
